import {createSlice} from "@reduxjs/toolkit";

const initialState={
    clientInternetSpeed:0,
    hostInternetSpeed:0,
    clientWindowInternetSpeed:0
}

const bandwidthSlice=createSlice({
    name:'bandwidth',
    initialState,
    reducers:{
        updateClientInternetSpeed(state,action){
            console.log(`Updating client internet speed in reducer: ${action.payload}`);
            state.clientInternetSpeed=action.payload;
        },
        updateHostInternetSpeed(state,action){
            console.log(`Updating host internet speed in reducer: ${action.payload}`);
            state.hostInternetSpeed=action.payload;
        },
        updateClientInternetSpeedClientWindow(state,action){
            state.clientWindowInternetSpeed=action.payload
        }

    }
})
export const{updateSendBandwidth,updateReceiveBandwidth,updateClientInternetSpeed,updateHostInternetSpeed,updateClientInternetSpeedClientWindow}=bandwidthSlice.actions;
export default bandwidthSlice.reducer;
